import {
  Card,
  Fade,
  makeStyles,
  Step,
  StepButton,
  Stepper
} from '@material-ui/core'
import React, { useEffect, useState } from 'react'

const useStyles = makeStyles(theme => ({
  stepper: {
    padding: 12
  },
  stepperPaper: {
    position: 'fixed',
    top: 64,
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 1050
  },
  stepBtn: {
    padding: '0px 16px'
  }
}))

const MiniStepper = props => {
  const { steps, activeStep, elementRef, handleStep, values } = props
  const classes = useStyles()
  const [miniStepper, setMiniStepper] = useState(false)

  const handleScroll = () => {
    const position = elementRef.current?.getBoundingClientRect() || 0
    if (position.y - 40 < 0 && miniStepper === false) {
      setMiniStepper(true)
      return
    }
    if (position.y - 40 > 0 && miniStepper === true) {
      setMiniStepper(false)
    }
  }

  useEffect(() => {
    const main = document.getElementsByTagName('main')[0]
    main.addEventListener('scroll', handleScroll)
    return () => {
      main.removeEventListener('scroll', handleScroll)
    }
  })

  return (
    <Fade in={miniStepper}>
      <Card className={classes.stepperPaper}>
        <Stepper className={classes.stepper} activeStep={activeStep} nonLinear>
          {steps.map((label, index) => (
            <Step key={label}>
              <StepButton
                disableRipple
                className={classes.stepBtn}
                onClick={() => {
                  if (values) {
                    handleStep(values, index)
                  } else {
                    handleStep(index)
                  }
                }}
              >
                {label}
              </StepButton>
            </Step>
          ))}
        </Stepper>
      </Card>
    </Fade>
  )
}

export default MiniStepper
